<template>
  <v-container>
    <Spinner v-if="!isInitialized" />
    <router-view
      :reports="reports"
      :loading="loading"
      :meta="meta"
      :filters="filters"
      v-if="isInitialized"
      @change:section="fetch"
      @search="onSearch"
      @reports:pagination="onPagination"
      @reports:filter="onChangeFilter"
    ></router-view>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Spinner from '@/components/shared/Spinner'
import reportTypes from '@/assets/data/reportTypes'

export default {
  name: 'ReportHome',
  components: {
    Spinner,
  },
  data() {
    return {
      loading: true,
      isInitialized: false,
    }
  },
   watch: {
    $route: {
      immediate: false,
      handler(to, from) {
        if(to.name === 'ReportsList' && from.name === 'ReportsList'){
          this.resetFilters()
          this.fetch()
        }
      },
    },
  },
  computed: {
    ...mapGetters('reports', { allReports: 'getArray', meta: 'getMeta', getFilters: 'getFilters' }),
    ...mapGetters('user', { getUserNameById: 'getUserNameById' }),

    reports() {
      return this.allReports.map((report) =>
        report.updated_by
          ? { ...report, updated_by: this.getUserNameById(report.updated_by) }
          : { ...report, updated_by: '' }
      )
    },
    section() {
      return reportTypes[this.$route.params.section]
    },
    filters() {
      return this.getFilters.reduce((obj, item) => ((obj[item.key] = item.value), obj), {})
    },
  },
  methods: {
    ...mapMutations('reports', {
      addReportsFilter: 'ADD_FILTER',
      setReportsOrder: 'SET_SORT',
      clearRapportFilters: 'CLEAR_FILTERS',
    }),
    ...mapActions('reports', { getReports: 'readCollection' }),

    resetFilters() {
      this.clearRapportFilters()
      this.addReportsFilter({ key: 'pageNumber', value: 1 })
      this.addReportsFilter({ key: 'pageSize', value: 20 })
      this.setReportsOrder({ key: 'created_at', value: 'DESC' })
    },

    onSearch(value) {
      this.addReportsFilter({ key: 'pageNumber', value: 1 })
      this.addReportsFilter({ key: 'article_title', value })
      this.fetch()
    },

    onPagination(value) {
      this.addReportsFilter({ key: 'pageNumber', value })
      this.fetch()
    },

    onChangeFilter(filter) {
      this.addReportsFilter({ key: 'pageNumber', value: 1 })
      this.addReportsFilter(filter)
      this.fetch()
    },

    async fetch() {
      this.loading = true
      this.addReportsFilter({ key: 'article_type', value: this.section })
      await this.getReports()
      this.loading = false
    },
  },
  async created() {
    this.addReportsFilter({ key: 'pageSize', value: 20 })
    this.setReportsOrder({ key: 'created_at', value: 'DESC' })
    await this.fetch()
    this.isInitialized = true
  },
}
</script>

<style lang="scss" scoped></style>
